import { configApi } from '../../../../shared/utils/http-client.js'

export const state = {
	dashboards: []
}

export const getters = {
	dashboards (state) {
		return state.dashboards
	}
}

export const mutations = {
	SET_DASHBOARDS (state, { dashboards, addCookieModule, addPrefPageAnalytics }) {
		// Override API dashboard names
		const dashboardNameOverrides = {
			1: 'Data Processing',
			3: 'Consent'
		}

		// Get dashboard IDs from the overrides constant
		const dataProcessingId = Number(Object.keys(dashboardNameOverrides).find(key =>
			dashboardNameOverrides[key] === 'Data Processing'))
		const consentId = Number(Object.keys(dashboardNameOverrides).find(key =>
			dashboardNameOverrides[key] === 'Consent'))

		// Apply name overrides to API dashboards
		const processedDashboards = dashboards
			.filter(d => [0, dataProcessingId, consentId].includes(d.id))
			.map(dashboard => ({
				...dashboard,
				name: dashboardNameOverrides[dashboard.id] || dashboard.name
			}))

		// Sort dashboards to put Consent Management before Data Processing
		const sortedDashboards = processedDashboards.sort((a, b) => {
			if (a.id === consentId && b.id === dataProcessingId) return -1 // Consent Management comes first
			if (a.id === dataProcessingId && b.id === consentId) return 1 // Data Processing comes second
			return 0 // Keep original order for other dashboards
		})

		const externalDashboards = []

		if (addCookieModule === true) {
			externalDashboards.push({
				id: 0,
				name: 'Consent Banners',
				isDefault: !sortedDashboards.some(d => d.isDefault)
			})
		}

		if (addPrefPageAnalytics === true) {
			externalDashboards.push({
				id: -1,
				name: 'Preference Page Analytics'
			})
		}

		state.dashboards = [...externalDashboards, ...sortedDashboards]
	}
}

export const actions = {
	getDashboards ({ commit }, { addCookieModule, addPrefPageAnalytics, submissionFragmentsEnabled }) {
		return new Promise((resolve, reject) => {
			configApi
				.get('/api/dashboard')
				.then(response => {
					const dashboards = response.data
					commit('SET_DASHBOARDS', { dashboards, addCookieModule, addPrefPageAnalytics })
					resolve(dashboards)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}
